export const FEEDBACK_TYPES = {
  EXPERT: 'expert',
  PRODUCT_SUPPORT: 'product_support',
} as const;

export type FeedbackType = (typeof FEEDBACK_TYPES)[keyof typeof FEEDBACK_TYPES];
